export default __webpack_public_path__ + "static/media/ride.c630c955.ogg";